module.exports = __webpack_public_path__ + "img/onlineRetailers-Marketing2.b59eb38a.png";